import CarrierForm from "kinnect-front/Warehouse/Carriers/CarrierForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { Carrier } from "kinnect-models";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";

export default {
	name: "CarrierPage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Carriers - ${this.carrier.name}`
			: "Carriers - Add a Carrier";

		return { title: this.fetched ? title : null };
	},

	props: { idCarrier: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "carriers",
		carrier: null,
		deleteDialogOpen: false
	} ),

	computed: {
		editing() {
			return Boolean( this.idCarrier );
		},

		genDeleteDialog() {
			if ( this.editing && this.carrier && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete carrier" )}
					onConfirm={() => this.carrier.delete()}
					redirect={[ "back", { name: "carriers" } ]}
					title="Delete Carrier"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the carrier <strong>{this.carrier.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Carrier",
					tooltip: "Delete this carrier"
				};
			}
		}
	},

	methods: {
		async fetchCarrier() {
			if ( this.editing ) {
				this.carrier = await Carrier.findPageModel( this.idCarrier );
			}
		},

		async fetch() {
			await this.fetchCarrier();
		}
	},

	render() {
		return <DefaultLayout maxWidth={this.editing ? "800px" : "600px" }>
			<CarrierForm
				carrier={this.carrier}
				loading={this.$wait.is( "find carrier" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></CarrierForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
